import React from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '../../context/AuthContext';
import { useT } from '../../i18n/LocaleContext';

/**
 * Clerk says this person is signed in and the app is still fetching (or could
 * not fetch) their account. Either way they stay where they are: sending them
 * to /login would only bounce them on, since Clerk's sign-in form passes a
 * signed-in session straight through to its redirect.
 */
export default function AccountPending() {
  const { authError, retryAuth, logout } = useAuth();
  const t = useT();

  if (!authError) {
    return (
      <div className="flex justify-center items-center min-h-screen" role="status" aria-label={t('auth.loadingAccount')}>
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm space-y-4 rounded-xl border bg-card p-6 text-center shadow-sm">
        <h1 className="text-lg font-semibold text-foreground">{t('auth.accountErrorTitle')}</h1>
        <p className="text-sm text-muted-foreground">{t('auth.accountErrorText')}</p>
        <div className="flex flex-col gap-2">
          <Button onClick={retryAuth}>{t('auth.tryAgain')}</Button>
          <Button variant="ghost" onClick={logout}>{t('auth.signOut')}</Button>
        </div>
      </div>
    </div>
  );
}
